import './App.css';
import Landing from './pages/Landing/Landing';
import useConfigAccessToken from './hooks/useConfigS3';
import Lottie from "lottie-react";
import loader from "./assets/memopet-loader.json";

function App() {

  let param = !!window.location.pathname.includes("code") ? window.location.pathname : "//";
  const { loading } = useConfigAccessToken();

  if (param.split('/').length > 3) {
    param = "//";
  }

  if (!loading) {
    return (
      <div className="App">
        <Landing route={param.split('/')[2]}/>
      </div>
    );
  } else {
    <div>
      <div className="loader-container">
        <Lottie className="loader" animationData={loader} loop={true} />
      </div>
    </div>
  }
}

export default App;

    //G-3gZwHYbB
    //C-H2r8dG5H



